// termsContent.js

export const termsOfService = `
Effective Date: 01/01/2025

Welcome to FloWire, a web-based platform operated by Lewi Software Group Pty Ltd ("we", "us", or "our"). These Terms of Service ("Terms") govern your use of our website, platform, software, and any related services (collectively, the "Services"). By accessing or using our Services, you agree to be bound by these Terms.

1. Eligibility and Account
You must be at least 18 years old and capable of forming a binding contract. You agree to provide accurate information and keep your account credentials secure. You are responsible for all activity on your account.

2. Subscriptions and Billing
Our Services may be offered through free and paid subscription tiers. Paid plans are billed in advance on a monthly or annual basis, depending on your selection. Prices are listed on our Site and may change with notice. You may cancel your subscription at any time through your Account settings. Fees are non-refundable unless required by law.

3. License and Acceptable Use
We grant you a limited, non-exclusive, non-transferable license to access and use the Services for your internal business use only. You agree not to:
•	Copy, reverse engineer, or attempt to extract the source code
•	Use the Services for unlawful purposes
•	Circumvent security or access controls
•	Share your account without authorization

4. User Content and Data
You retain ownership of any data or content you submit ("User Content"). You grant us a non-exclusive license to use, process, store, and analyze User Content as needed to provide and improve the Services. You are solely responsible for ensuring you have the right to submit such content.

5. Privacy
We respect your privacy. Our collection and use of personal information is governed by our Privacy Policy. By using the Services, you consent to our data practices.

6. Third-Party Services
Our Services may interface with or include links to third-party tools. We are not responsible for the content, availability, or accuracy of third-party services.

7. Service Availability
We aim to maintain high availability but do not guarantee uninterrupted access. From time to time, we may perform updates or maintenance that may impact access.

8. Intellectual Property
All rights, title, and interest in the Services and all related intellectual property belong to us. You may not reproduce, resell, or exploit any part of the Services without express permission.

9. Termination
You may stop using the Services at any time. We may suspend or terminate your access if you breach these Terms. Upon termination, your access will cease and your data may be deleted after a reasonable retention period.

10. Disclaimer & Limitation of Liability
The Services are provided "as-is" without warranties of any kind. To the maximum extent permitted by law, we disclaim all liability for indirect, incidental, or consequential damages. Our total liability will not exceed the amount you paid us in the past 12 months.

11. Changes to Terms
We may update these Terms from time to time. Continued use of the Services after changes constitutes your acceptance. We will notify users of material changes via email or through the Services.

12. Governing Law
These Terms are governed by the laws of Queensland, Australia. Disputes will be subject to the exclusive jurisdiction of the courts of Queensland.

13. Contact Us
If you have questions, please contact us at contact@lewisoftware.com.

`;

export const privacyPolicy = `
Effective Date: 01/01/2025

This Privacy Policy explains how Lewi Software Group Pty Ltd ("we", "us", or "our") collects, uses, and discloses information when you use FloWire (the "Service").

1. Information We Collect
•	Account Information: Name, email, organization, and login credentials.
•	Usage Data: Interactions with the Service, log files, IP address, browser type.
•	User Content: Any data or materials you input or upload while using the Service.
•	Cookies: For session management and analytics.

2. How We Use Your Information
•	Provide and maintain the Service
•	Improve and personalize the user experience
•	Communicate with you about updates, support, and billing
•	Monitor and analyze usage trends
•	Comply with legal obligations

3. Sharing of Information
We do not sell your personal data. We may share information:
•	With third-party service providers for business operations (e.g., hosting, analytics)
•	If required by law or to respond to legal process
•	To protect our rights or the safety of users

4. Data Retention
We retain your data as long as your account is active or as necessary for legal or operational purposes. You may request deletion by contacting us.

5. Security
We use industry-standard measures to protect your data. However, no method of transmission is 100% secure.

6. Your Rights
You may access, update, or delete your personal information through your account or by contacting us. You may also opt out of marketing emails.

7. International Users
If you access the Service from outside Australia, your data may be processed in Australia or other jurisdictions with different data laws.

8. Changes to This Policy
We may update this Privacy Policy. We will notify you of significant changes and update the effective date.

9. Contact Us
If you have questions, please contact us at contact@lewisoftware.com.

`;
